export const getActiveState = (states) => {
  const activeState = Object.entries(JSON.parse(states)).filter(
    (item) => item[1].active === 1
  );
  if (activeState.length === 0) return null;
  return activeState[0][0];
};

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}

export function hideNumber(string, user, channel) {
  if (parseInt(string)) {
    let result = string.match(
      /^(\(?\+?\d{1,2}\)? ?\(?\d{1,3}\)? ?\d+\-? ?\d+\-? ?\d+)$/
    );

    if (user && user === string) {
      let idRandomEnd = getRandomInt(1000, 9999);
      if (['tgcomm', 'telegram'].includes(channel)) {
        let idRandomStart = getRandomInt(10, 99);
        return `${idRandomStart}****${idRandomEnd}`;
      }
      return `+796****${idRandomEnd}`;
    }

    if (result !== null) {
      var hidedNumber = Array.from(string).reduceRight(
        function (ctx, char) {
          var isDigit = char >= '0' && char <= '9';
          var offset = ctx.offset + (isDigit ? 1 : 0);
          var filteredChar = isDigit
            ? offset >= 4 && offset < 8
              ? '*'
              : char
            : char;
          var filtered = filteredChar + ctx.filtered;
          return { offset: offset, filtered: filtered };
        },
        { offset: -1, filtered: '' }
      ).filtered;
      return `${string.startsWith('7') ? '+' : ''}${hidedNumber}`;
    } else {
      return string;
    }
  }
  return string;
}

export const formatPhoneNumber = (phone = '', delimiter = ' ') => {
  let res = '';

  if (!phone) {
    return res;
  }

  let phoneNumber = phone.startsWith('+') ? phone : `+${phone}`;
  for (let i = 0; i < phoneNumber.length; i++) {
    const char = phoneNumber[i];

    if (phoneNumber.includes('+7') || phoneNumber.includes('+8')) {
      if ([0, 2, 3, 5, 6, 8, 10, 11].includes(i)) {
        res += char;
      } else if ([1, 4].includes(i)) {
        res += `${char} `;
      } else if ([7, 9].includes(i)) {
        res += `${char}${delimiter}`;
      }
    }
    // код Молдовы
    else if (phoneNumber.includes('+373')) {
      if ([0, 1, 2, 4, 5, 6, 8, 9, 10, 11].includes(i)) {
        res += char;
      } else if ([3].includes(i)) {
        res += `${char} `;
      } else if ([7].includes(i)) {
        res += `${char}${delimiter}`;
      }
    } else {
      res += char;
    }
  }

  return res;
};

export const maskNumber = (senderNumber = '', user, channel) => {
  const isTelegram = channel === 'telegram' || channel === 'tgcomm';
  const templatePhone = '+7961****';
  const templateId = '@ID*****';

  if (!senderNumber) {
    let telRandom = getRandomInt(100, 999);
    return `${templatePhone}${telRandom}`;
  }

  if (senderNumber === user && isTelegram) {
    let idRandom = getRandomInt(1000, 9999);
    return `${templateId}${idRandom}`;
  }
  if (senderNumber === user) {
    let telRandom = getRandomInt(100, 999);
    return `${templatePhone}${telRandom}`;
  }

  if (
    (senderNumber.startsWith('7') || senderNumber.startsWith('8')) &&
    senderNumber.length === 11 &&
    !isTelegram
  ) {
    let numberToSpace = [];

    let phone = Array.from(senderNumber).reduce(function (ctx, char, index) {
      let isDigit = char >= '0' && char <= '9';

      let filteredChar = isDigit
        ? index >= 4 && index < 8
          ? '*'
          : char
        : char;
      return ctx + filteredChar + (numberToSpace.includes(index) ? ' ' : '');
    }, '');

    return `+${phone}`;
  } else if (!isTelegram) {
    let telEnd = senderNumber.slice(-3);
    return `${templatePhone}${telEnd}`;
  } else {
    let id = senderNumber.slice(-4);
    return `${templateId}${id}`;
  }
};
